import type { Nullable } from '../models';
import type { AdProduct, Config } from '.';
import { AD_TYPE_PUBLISHER_RESTRICTIONS_MAP } from '.';
import type { AdType } from './adTypes';
import { adTypes } from './adTypes';

const permittedAdTypes: Record<AdProduct, Config<AdType>[]> = {
  AD_SELECTOR: [adTypes.AD_SELECTOR],
  AD_SELECTOR_SLATE: [adTypes.AD_SELECTOR_SLATE],
  AD_SELECTOR_VIDEO: [adTypes.AD_SELECTOR_VIDEO],
  BE_SELECTOR: [adTypes.BE_SELECTOR_SLATE, adTypes.BE_SELECTOR_VIDEO],
  BINGE_AD_FREE: [adTypes.BRIGHTLINE],
  BINGE_REWARD: [adTypes.VIDEO],
  BINGE_SLATE: [adTypes.SLATE],
  BINGE_TEASER: [adTypes.VIDEO],
  BINGE_VIDEO: [adTypes.VIDEO],
  BRIGHTLINE: [adTypes.BRIGHTLINE],
  COLLECTION_LOGO: [adTypes.COLLECTION_LOGO],
  COVER_STORY_LOGO: [adTypes.COVER_STORY_LOGO],
  GATEWAY_GO: [adTypes.GATEWAY_GO, adTypes.INSTREAM_DXC],
  GATEWAY_SHOP: [adTypes.GATEWAY_SHOP],
  HUB_LOGO: [adTypes.HUB_LOGO],
  INNOVID: [adTypes.INNOVID],
  MARQUEE: [adTypes.MARQUEE_PROMOTED_CONTENT],
  MAX_SELECTOR: [adTypes.MAX_SELECTOR],
  PAUSE: [adTypes.PAUSE, adTypes.OUTSTREAM_DXC],
  SLATE: [adTypes.SLATE],
  VIDEO: [adTypes.VIDEO],
  HOUSE_VIDEO: [adTypes.VIDEO],
  PAUSE_PLUS: [adTypes.OUTSTREAM_DXC],
  CHOICE: [adTypes.INSTREAM_DXC],
  VIDEO_PLUS: [adTypes.INSTREAM_DXC],
  STREAMPASS: [adTypes.VIDEO],
};

export type GetPermittedAdTypes = {
  adProductKey: AdProduct;
  displayPublisherTarget: Nullable<string[]>;
};

export function getPermittedAdTypes({ adProductKey, displayPublisherTarget }: GetPermittedAdTypes): Config<AdType>[] {
  const configAdTypes = permittedAdTypes[adProductKey];

  if (displayPublisherTarget && displayPublisherTarget.length) {
    let result = new Set<Config<AdType>>();

    // if publisher has conflicts with ad types,
    // we exclude ad type,
    // but if another publisher can have excluded ad type,
    // this ad type should be present in the list
    displayPublisherTarget.forEach((publisherKey) => {
      configAdTypes.forEach((adType) => {
        const publisherExclusions = AD_TYPE_PUBLISHER_RESTRICTIONS_MAP[adType.key]?.exclude;

        if (!publisherExclusions || !publisherExclusions.includes(publisherKey)) {
          result.add(adType);
        }
      });
    });

    return Array.from(result);
  }

  return configAdTypes;
}
